module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_shimane-0658b4a432aa02b7ed51ffd312393246.png";